// Centralized brand constants
export const CONTACT_PHONE_RAW = "918584884787";
export const CONTACT_PHONE = "+91 85848 84787";
export const WHATSAPP_URL = `https://wa.me/${CONTACT_PHONE_RAW}`;

// Build a WhatsApp deep link with a pre-filled first message.
// Used so a message from the Dining page opens WhatsApp already saying,
// "Hello FarmStory, I'd like to ask about tonight's menu," etc.
export function waLink(text) {
  if (!text) return WHATSAPP_URL;
  return `${WHATSAPP_URL}?text=${encodeURIComponent(text)}`;
}
export const OTA_URL = WHATSAPP_URL;
export const CONTACT_EMAIL = "reachus@farmstoryindia.com";
export const CONTACT_ADDRESS = "Near Raja More, Jharkhali, Lot No 126, West Bengal 743312, India";
export const CONTACT_ADDRESS_SHORT = "Jharkhali · Sundarbans · West Bengal";
export const MAP_URL = "https://maps.app.goo.gl/mmkXdpqtuGCwVD116";
export const MAP_COORDS = { lat: 22.0454084, lng: 88.664721 };
export const PLUS_CODE = "2MW7+5V Lot No 126, West Bengal";
export const LOGO_SRC = "/brand/farmstory-logo.webp";
export const MNEMONIC_SRC = "/brand/mnemonic.webp";
